function isPdfLink(link) {
    const href = link.getAttribute("href");
    return href && /\.pdf(?:$|[?#])/i.test(href);
}

function getPdfUrl(link) {
    const url = new URL(link.getAttribute("href"), document.baseURI);
    url.hash = "";
    return url;
}

function getPdfFileName(url) {
    const segments = url.pathname.split("/");
    return decodeURIComponent(segments[segments.length - 1]);
}

function viewerUrl(pdfUrl) {
    return `${pdfUrl.href}#view=FitH&toolbar=0&navpanes=0`;
}

function createSlideshow(pdfUrl) {
    const slideshow = document.createElement("div");
    slideshow.className = "pdf-slideshow";

    const frame = document.createElement("iframe");
    frame.className = "pdf-slideshow__frame";
    frame.loading = "lazy";
    frame.src = viewerUrl(pdfUrl);
    frame.title = `Vista de ${getPdfFileName(pdfUrl)}`;

    slideshow.append(frame);
    return slideshow;
}

function attachSlideshows() {
    document.querySelectorAll("a[href]").forEach((link) => {
        if (!isPdfLink(link) || link.dataset.pdfSlideshowReady === "true") {
            return;
        }

        const pdfUrl = getPdfUrl(link);
        const host = link.closest("li") || link.parentElement;

        if (!host) {
            return;
        }

        link.dataset.pdfSlideshowReady = "true";
        host.appendChild(createSlideshow(pdfUrl));
    });
}

document.addEventListener("DOMContentLoaded", attachSlideshows);
